module.exports = __webpack_public_path__ + "img/app-store-button.83553fa9.svg";